import type { FaireCollectionEntity } from "../../entity_types/collection";

export const col_japandi: FaireCollectionEntity = {
  token: "col_japandi",
  type: "collection",
  name: "Japandi",
  description:
    "Where Scandinavian simplicity meets Japanese serenity. A blend of clean lines, natural warmth, and modern minimalism.",
  thumbnailUrl:
    "https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?w=400&h=400&fit=crop",
  heroImageUrl:
    "https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?w=1200&h=600&fit=crop",
  season: "new",
  itemCount: 32,
  brandToken: "catalog_brand_audreys_home_gift",
  productTokens: [],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
